import { Gender } from "@dcc/types/gender";
import { maxWeeklyDrinks, maxUnitsPerDay } from "@dcc/constants/drinkConstants";

export const getIsDangerousToHealth = (
  totalDrinksPerWeek: number,
  gender: Gender
) => totalDrinksPerWeek > maxWeeklyDrinks[gender];

export const getIsBingeDrinker = (highestUnitsPerday: number, gender: Gender) =>
  highestUnitsPerday > maxUnitsPerDay[gender];
